
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import {SessionGetCurrentLoginInformations} from '@/api';
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/entities/page-request'
import CommonTable from '@/components/common-table/index.vue'
import User from '@/entities/user'
import TableAction from '@/entities/table-action'
import CardBody from '@/components/card-body/index.vue'
import SortDropdown from '@/components/sort-dropdown/index.vue'
import WorkingZonePanel from '@views/setting/workingzone/panel.vue'
import tableSingleCheck from '@/mixins/table-single-check'
import tableSort from '@/mixins/table-sort'
import { ElTable } from 'element-ui/types/table'
import WorkingZone from '@/entities/workzone'
import util from '@/lib/util'
import ExportImportBtn from '@/components/export-import-btn/index.vue'

class PageListRequest extends PageRequest {
  //add search field : step 1 : add variable for search
  workingZone: string
  }

@Component({
  components: {
    CommonTable,
    CardBody,
    SortDropdown,
    WorkingZonePanel,
    ExportImportBtn
  },
  mixins: [tableSingleCheck, tableSort]
})
export default class WorkingZoneMaster extends AbpBase implements TableAction<WorkingZone> {
  [x: string]: any
  pagerequest: PageListRequest = new PageListRequest()

  isPanelExpand: boolean = false

  selectItem: WorkingZone = null

  get tableLoading() {
    return this.$store.state.workingzone.loading
  }

  get tableDataList() {
    return this.$store.state.workingzone.list
  }

  get tablePagination() {
    return {
      pageNo: this.$store.state.workingzone.currentPage,
      pageSize: this.$store.state.workingzone.pageSize,
      total: this.$store.state.workingzone.totalCount
    }
  }

  table = this.$standardTableData({
    hideHeader: false,
    title: this.L('WorkingZone'),
    hasCheckbox: true,
    query: {
      //add search field : step 2 : set query for search variable
      workingZone: null
    },
    searchData: 
    [
      //add search field : step 3 : set search settings
      {
        type: 'input',
        title: 'Store',
        model: 'workingZone'
      }
    ],
    columns: [
      {
        key: 'collapseColumn',
        hide: true,
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.collapseColumn(ctx.row)
          )
        }
      },
      {
        title: this.L('Working Zone'),
        sortable: true,
        key: 'workingZone'
      },
      {
        title: this.L('Type'),
        sortable: true,
        key: 'type'
      },
      {
        title: this.L('Location Code'),
        sortable: true,
        key: 'locCode'
      },
      {
        title: this.L('Name'),
        sortable: true,
        key: 'name'
      }
    ]
  })

  async doTableSearch() {
    this.pagerequest.maxResultCount = this.tablePagination.pageSize
    this.pagerequest.skipCount =
      (this.tablePagination.pageNo - 1) * this.tablePagination.pageSize
    //add search field : step 4 : send keyword to api
    this.pagerequest.workingZone = this.table.query.workingZone
    await this.$store.dispatch({
      type: 'workingzone/getAll',
      data: this.pagerequest
    })
  }

  doTablePageSizeChange(pageSize: number) {
    this.$store.commit('workingzone/setPageSize', pageSize)
    this.doTableSearch()
  }

  doTablePageChange(pageNo: number) {
    this.$store.commit('workingzone/setCurrentPage', pageNo)
    this.doTableSearch()
  }

  doTableRowClick(rowData: WorkingZone) {
    this.isPanelExpand = true
    this.selectItem = rowData
  }

  handleTableSort(itemKey, sortBy) {
    if (sortBy === 'none') {
      this.pagerequest.sorting = null
    } else {
      this.pagerequest.sorting = `${itemKey} ${sortBy}`
    }
    this.doTablePageChange(1)
  }

  getTableRef(): ElTable {
    return this.$refs.commonTable as ElTable
  }

  importLoading = false
  /**
   * 导入数据
   */
  async handleImportFile(e) {
    const file = (e || {}).file
    if (!file) {
      return
    }
    try {
      this.importLoading = true
      let formData = new FormData()
      formData.append('file', file)
      let res = await this.$store.dispatch({
        type: 'workingzone/importWorkingZoneListFromExcel',
        data: formData
      })
      if (!res.data.success) {
        this.$notify.error({
          title: 'Error',
          message: res.data.error.message
        })
        return
      }

      /*
      let rep = await SessionGetCurrentLoginInformations({
        headers: {
          'Abp.TenantId': util.abp.multiTenancy.getTenantIdCookie()
          }
        }
      );

      let impres = await this.$store.dispatch({
        type: 'userimport/getUserImportResultByUserId',
        id: rep.data.result.user.id
      })

      this.importResult = impres || {}

      if(this.importResult.importStatus != 1){
        this.$notify.error({
          title: 'Error',
          message: this.importResult.lastImportResult
        })
        return
      }
      */
     
      this.$notify.success({
        title: 'Success',
        message: 'Import Success'
      })
      this.doTableSearch()
    } catch (e) {
      console.log(e)
    } finally {
      this.importLoading = false
    }
  }

  downloadLoading = false
  /**
   * 下载模板
   */
  async doDownloadTemplate(filename) {
    try {
      this.downloadLoading = true
      let res = await this.$store.dispatch({
        type: 'workingzone/downloadWorkingZoneListExcel'
      })
      util.downloadRawDataToFile(filename, res.data)
    } catch (e) {
      console.log(e)
    } finally {
      this.downloadLoading = false
    }
  }

  @Watch('isPanelExpand', { immediate: true, deep: true })
  onPanelExpandChange(newVal) {
    if (newVal) {
      this.table.hideHeader = true
      this.table.columns.map(t => {
        t.hide = t.key !== 'collapseColumn'
      })
    } else {
      this.table.hideHeader = false
      this.table.columns.map(t => {
        t.hide = t.key === 'collapseColumn'
      })
    }
  }

  doExpandClose() {
    this.isPanelExpand = false
    this.selectItem = null
  }

  /**
   * 删除id
   */
  async doDelete(id) {
    await this.$confirmWithApi(
      'Do you want to delete this working zone?',
      'Delete',
      async () => {
        await this.$store.dispatch({
          type: 'workingzone/delete',
          id
        })
      }
    )
    this.doTableSearch()
  }

  /**
   * 批量删除
   */
  async doBatchDelete() {
    let ids = (this.checkedItems || []).map(t => {
      return t.id
    })
    await this.$confirmWithApi(
      'Do you want to delete those working zones?',
      'Delete',
      async () => {
        await this.$store.dispatch({
          type: 'workingzone/batchDelete',
          data: ids
        })
      }
    )
    this.doCancelAllSelection()
    this.doTableSearch()
  }

  doEdit(id: number) {
    this.doNew(id)
  }

  doNew(id?: number) {
    this.$router.push({
      name: 'WorkingZoneEdit',
      params: {
        id: id + ''
      }
    })
  }

  // 可操作动作
  tableActionList = [
    {
      icon: 'el-icon-download',
      key: 'export',
      name: 'Export'
    }
  ]

  async doTableAction() {
    try {
      let fileInfo = await this.$store.dispatch({
        type: 'workingzone/workingZoneExport',
        data: {
          sorting: this.pagerequest.sorting,
          filter: null,
          fileType: 'xlsx'
        }
      })
      if (!fileInfo) {
        return
      }
      let res = await this.$store.dispatch({
        type: 'app/downloadTempFile',
        data: fileInfo
      })
      util.downloadRawDataToFile(fileInfo.fileName, res.data)
      this.$notify.success({
        title: 'Success',
        message: 'Export Success'
      })
    } catch (e) {
      console.log(e)
      this.$notify.error({
        title: 'Failed',
        message: 'Export Failed'
      })
    }
  }

  created() {
    this.initTableColumnSort(this.table.columns)
    this.doTableSearch()
  }
}
